<template>
  <div v-if="false"></div>
</template>

<script setup lang="ts">
import useToast from '@lib/composables/useToast'

const { initMessageProvider } = useToast()

initMessageProvider()
</script>
